<template>
  <section>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <div>
            <h1 class="title-view">
              Rates of Destination
            </h1>

            <div class="box-id">
              <h2 class="number-id">
                {{ branchs.name }}
              </h2>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 alinmov3">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0"
              type="outline-neutral"
              class="min-button btn-line-danger"
              @click="deleteMany()"
            >
              <i class="flaticon-delete"></i>Delete
            </base-button>

            <base-button
              type="primary"
              class="min-button"
              @click="$router.push(`/rates/new?branch=${$route.params.id}`)"
            >
              <i class="flaticon-plus"></i> New Rate
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="row">
        <div
          class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2 mb-lg-0 mb-3"
        ></div>

        <div
          class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-3 text-right"
        >
          <div class="d-inline-block mr-2">
            <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-1">
              <b-form-radio-group
                id="btn-radios-view"
                v-model="view"
                :aria-describedby="ariaDescribedbyview"
                name="radios-btn-default"
                buttons
                @change="changeViewCard"
                class="mb-0"
                button-variant="outline-neutral pc-3"
              >
                <b-form-radio value="table"
                  ><i class="flaticon-two" title="View Table"></i
                ></b-form-radio>
                <b-form-radio value="card"
                  ><i class="flaticon-menu" title="View Card"></i
                ></b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div class="d-inline-block mr-2">
            <el-tooltip content="Export" placement="bottom">
              <base-dropdown
                menu-on-right
                class="nav-item"
                tag="div"
                title-tag="a"
                title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                title="Export"
              >
                <base-button slot="title" type="none" class="p-0 min-button">
                  <i class="flaticon-downloading-files mr-0 mt-2"></i>
                </base-button>

                <div
                  class="dropdown-item"
                  @click="download(selectedRows)"
                  v-if="selectedRows.length > 0"
                >
                  Selected Records
                </div>
                <div class="dropdown-item" @click="download()">
                  All Records
                </div>
              </base-dropdown>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div>
        <pagination-block
          :pageCount="rates.pages"
          v-model="currentPage"
          :total="rates.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="preventPaginations"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="rates.docs"
          :fields="fields"
          sort-by.sync="category"
          sort-asc.sync="true"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :stacked="cardview"
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == documents.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template #cell(type)="data">
            <router-link
              :to="`/rates/${data.item._id}?branch=${$route.params.id}`"
              class="box-img-card"
              v-if="data.item.vehicle"
            >
              <div class="img-car">
                <img
                  :src="data.item.vehicle.information.image"
                  class="img-fluid es-img-service-2"
                  alt="Service Car"
                />
              </div>

              <div class="content ">
                <span class="capitalize hide-data title">
                  {{ data.item.vehicle.parameters.category | category }}
                </span>

                <span class="hide-data subtitle-1" v-if="data.item.vehicle">{{
                  data.item.vehicle.parameters.name
                }}</span>
                <span class="hide-data subtitle-2" v-if="data.item.vehicle">{{
                  data.item.vehicle.parameters.type | typeVehicle
                }}</span>
              </div>
            </router-link>
          </template>

          <template #cell(branch)="data">
            <span class="hide-data" v-if="data.item.branch"
              >{{ data.item.branch.name }}
            </span>
          </template>

          <template #cell(pricing)="data">
            <span>
              {{ data.item.type_of_quote | quote }}
            </span>
          </template>

          <template #cell(seats)="data">
            <span v-if="data.item.vehicle">{{
              data.item.vehicle.parameters.n_seats
            }}</span>
          </template>

          <template #cell(area_of_action)="data">
            <span class="hide-data">{{
              getAreaOfActionLength(data.item.area_of_action)
            }}</span>
          </template>

          <template #cell(especial_conditions)="data">
            <span> {{ getSurcharges(data.item.surcharges) }} </span>
          </template>

          <template #cell(price)="data">
            <div v-if="getAreaOfActionLength(data.item.area_of_action)">
              <span
                >{{ data.item.currency_symbol }}
                {{ getMinPrice(data.item.area_of_action) }}
                {{ data.item.currency_code }}</span
              >
            </div>
            <div v-else>
              <span
                >{{ data.item.currency_symbol }}
                {{ addecimal(data.item.base_price) }}
                {{ data.item.currency_code }}</span
              >
            </div>
          </template>

          <template #cell(price_extra)="data">
            <span>
              {{ data.item.currency_symbol }}
              {{ addecimal(data.item.price_extra_km) }}
              {{ data.item.currency_code }}
            </span>
          </template>

          <template #cell(status)="data">
            <span
              class="badge-status"
              v-bind:class="getClassByRateStatus(data.item.status)"
            >
              {{ getRateStatus(data.item.status) }}
            </span>
          </template>

          <template #cell(actions)="data">
            <el-tooltip content="Edit" placement="bottom">
              <router-link
                class="icon-action text-blue mr-2"
                :to="`/rates/${data.item._id}?branch=${$route.params.id}`"
              >
                <i class="flaticon-pencil text-primary"></i>
              </router-link>
            </el-tooltip>

            <el-tooltip content="Change status" placement="bottom">
              <span
                class="icon-action "
                @click.stop="changeRateStatus(data.item._id, data.item.status)"
              >
                <i class="flaticon-right-4 text-info"></i>
              </span>
            </el-tooltip>

            <el-tooltip content="Delete" placement="bottom">
              <span
                class="icon-action text-danger ml-2"
                @click="deleteRate(data.item._id)"
              >
                <i class="flaticon-delete"></i>
              </span>
            </el-tooltip>
          </template>
        </b-table>

        <pagination-block
          :pageCount="rates.pages"
          v-model="currentPage"
          :total="rates.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="preventPaginations"
          position="bottom"
        ></pagination-block>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import endpoint from "../../Commons/Services/index";
import Swal from "sweetalert2";
import localHelper from "../commons/Helper";
import WSelect from "@/components/Select";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import { goBack, unauthorizedAction } from "../../../helpers/commons.helpers";
export default {
  name: "Destinations",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    WSelect
  },
  data() {
    return {
      currentPage: 1,
      selectedRows: [],
      modal: false,
      branchs: {
        name: ""
      },
      branchId: null,
      limit: 0,
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "type",
          label: "Vehicle",
          sortable: true,
          thStyle: { minWidth: "160px" },
          class: "text-left"
        },
        {
          key: "branch",
          label: "Destination",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "text-left"
        },

        {
          key: "pricing",
          label: "Pricing Selections",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "alinmov6"
        },
        {
          key: "seats",
          label: "N° Seats",
          sortable: true,
          thStyle: { minWidth: "50px" },
          class: "alinmov7"
        },
        {
          key: "area_of_action",
          label: "Areas",
          sortable: true,
          thStyle: { minWidth: "50px" },
          class: "alinmov7"
        },

        {
          key: "especial_conditions",
          label: "Especial Cond.",
          sortable: true,
          thStyle: { minWidth: "50px" },
          class: "alinmov7"
        },

        {
          key: "price",
          label: "Price",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov7"
        },

        {
          key: "price_extra",
          label: "Price Extra KM",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov7"
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "text-center"
        },

        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      cardview: false,
      view: "table"
    };
  },

  async created() {
    var bread = [
      {
        text: "Destinations",
        to: "/destinations"
      },

      {
        text: "Rates of Destination",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.branchId = this.$route.params.id;
    this.getBranch(this.branchId);
    await this.getLimit();
    this.limit = this.paginationLimit;
    await this.get(true, this.branchId, this.limit, this.currentPage);
  },
  methods: {
    async changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        await this.get(true, this.branchId, this.limit, this.currentPage);
      }
    },
    async preventPaginations(page) {
      await this.get(true, this.branchId, this.limit, page);
    },
    async nextPaginations(page) {
      await this.get(true, this.branchId, this.limit, page);
    },
    async changePage(page) {
      await this.get(true, this.branchId, this.limit, page);
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    async deleteRate(rateId) {
      let { value } = await Swal.fire({
        title: "Delete Service",
        text: "Are you sure do you want to delete this Service?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteRateById(rateId);
      }
    },
    async deleteRateById(areaId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.rates.services.deleteRateById(
          areaId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(true, this.branchId, this.limit, 1);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Service has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async deleteMany() {
      let { value } = await Swal.fire({
        title: "Delete Services",
        text: "Are you sure do you want to delete the selected Services?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyRatesById(this.selectedRows);
      }
    },
    async deleteManyRatesById(rates = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.rates.services.deleteManyRatesById(
          { services: rates },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(true, this.branchId, this.limit, 1);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Services has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async download(services = []) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.exports.services.exportCSVServices(
          { services: services },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `services.csv`);
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    getAreaOfActionLength(area_of_action) {
      if (area_of_action.length) {
        return area_of_action.length;
      } else {
        if (area_of_action.name != null) {
          return 1;
        }
      }
      return 0;
    },
    getMinPrice(area_of_action) {
      let min_price;
      if (area_of_action.length) {
        let area_of_action_prices = area_of_action.map(
          area_of_action => area_of_action.price
        );
        min_price = Math.min(...area_of_action_prices);
      } else {
        min_price = area_of_action.price;
      }
      return min_price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    addecimal: function(price) {
      var total = price;
      return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    async getBranch(branchId) {
      try {
        let { data } = await endpoint.branches.services.getBranchById(
          branchId,
          this.sesion.token
        );
        if (data.code === 200) {
          let branch = data.data;
          this.branchs.name = branch.name;
        } else {
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async get(loader, branchId, limit, page) {
      await this.getRatesByBranchId({
        loader: loader,
        branchId: branchId,
        limit: limit,
        page: page,
        query: ""
      });
    },

    getSurcharges(surcharges = []) {
      if (surcharges.length) {
        return surcharges.length;
      } else {
        return 0;
      }
    },
    typeEvent(type) {
      if (type === "blackouts") {
        return "Blackouts Dates";
      } else if (type === "special_event") {
        return "Special Event";
      } else if (type === "weekend_dates") {
        return "Weekend Fees";
      } else if (type === "night_fees") {
        return "Night Fees";
      } else if (type === "seasonal") {
        return "Seasonal Fees";
      }
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },

    getClassByRateStatus(status) {
      if (status === "ACTIVE") {
        return "badge-success";
      } else if (status === "INACTIVE") {
        return "badge-danger";
      } else if (status === "EXPIRED") {
        return "status-draft";
      } else {
        return {};
      }
    },
    getRateStatus(status) {
      if (status === "ACTIVE") {
        return "Active";
      } else if (status === "INACTIVE") {
        return "Inactive";
      } else if (status === "EXPIRED") {
        return "Expired";
      } else {
        return "Unknow";
      }
    },
    async changeRateStatus(rateId, status) {
      if (status !== "EXPIRED") {
        let { value } = await Swal.fire({
          title: "Change Status Rate",
          html:
            "Are you sure you want to <strong>Change Status</strong> of the selected Rate?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.changeRateStatusById(
            rateId,
            status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
          );
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Validation error!",
          message: `The Rate couldn't be uploaded. Please update the validity period of this rate.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async changeRateStatusById(rateId, status) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.rates.services.updateAnyAttributeById(
          rateId,
          { status: status },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          await this.get(false, this.branchId, this.limit, this.currentPage);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Rate Status has been Updated",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    ...mapActions(["getRatesByBranchId", "getLimit"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setBranchesSearchCriteria"
    ])
  },
  computed: {
    documents: function() {
      if (this.rates.docs) {
        return this.rates.docs;
      } else {
        return [];
      }
    },
    ...mapGetters([
      "rates",
      "sesion",
      "sigout",
      "paginationLimit",
      "ratesSearchCriteria"
    ])
  },
  filters: {
    category: function(type) {
      if (type === "standard") {
        return "Standard Class";
      } else if (type === "business") {
        return "Business Class";
      } else {
        return "Luxury Class";
      }
    },
    typeCategory: function(type) {
      if (type === "car") {
        return "Car";
      } else if (type === "van") {
        return "Van";
      } else {
        return "Coach";
      }
    },
    typeVehicle: function(type) {
      if (type === "sedan") {
        return "Sedan";
      } else if (type === "boat") {
        return "Boat";
      } else if (type === "coach") {
        return "Coach";
      } else if (type === "limousine") {
        return "Limousine";
      } else if (type === "minibus") {
        return "Minibus";
      } else if (type === "midicoach") {
        return "Midicoach";
      } else if (type === "minivan") {
        return "Minivan";
      } else if (type === "mpv") {
        return "Mpv";
      } else if (type === "pickup") {
        return "Pickup";
      } else if (type === "premium_sedans") {
        return "Premium Sedans";
      } else if (type === "suvs") {
        return "SUVs";
      }
    },
    currency: function(country) {
      if (country === "United States of America") {
        return "$";
      } else if (
        country === "United Kingdom of Great Britain and Northern Ireland"
      ) {
        return "£";
      } else {
        return "€";
      }
    },
    quote: function(type) {
      if (type === "area") {
        return "Area + Distance";
      } else {
        return "By Distance";
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    localHelper.isInBranchesModule(
      to.meta.modules,
      this.setBranchesSearchCriteria,
      "destinations"
    );
    next();
  }
};
</script>
